/**
 * Whether the boundary repairs a media_server's data that breaks its schema: the deployment's
 * STRICT_MEDIA_SERVER. See *A media_server far behind* in docs/rules/api_boundary.md.
 */

import type { ViolationSource } from '@/types/contract';
import { ViolationSourceKind } from '@/types/contract';

import { fetchStrictMediaServer } from './runtimeConfig';

/** Strict until the switch is read: a parse cannot wait for the file. */
export class MediaServerStrictness {
    private strict = true;

    private readonly fetchStrict: () => Promise<boolean>;

    constructor(fetchStrict: () => Promise<boolean> = fetchStrictMediaServer) {
        this.fetchStrict = fetchStrict;
    }

    /** Reads the switch; the page calls it once, as it starts. */
    async load(): Promise<void> {
        this.strict = await this.fetchStrict();
    }

    /** The cloud brings what it stores up to date itself; a media_server's data is repaired. */
    isLenient(source: ViolationSource): boolean {
        if (this.strict) {
            return false;
        }
        switch (source.kind) {
            case ViolationSourceKind.Relay:
                return true;
            case ViolationSourceKind.Cloud:
            case ViolationSourceKind.Peer:
                return false;
        }
    }
}

export const mediaServerStrictness = new MediaServerStrictness();
